import { observable, action } from 'mobx'

import { getBrandBySlug, getBrandById } from 'src/utils/brand'
import config from 'src/config'

export default class Brand {
  @observable activeBrand: null | any = null
  @observable transparent: boolean = false

  @action.bound
  setBrandHeader = (id: string | null, landing?: boolean) => {
    if (id) {
      const brand = getBrandById(id)
      if (brand) {
        this.setActiveBrand(brand)
        this.setHeaderBackground(landing ? true : false)
      } else {
        this.setActiveBrand(null)
      }
    } else {
      this.setActiveBrand(null)
    }
  }

  @action.bound
  getPreviewBrand = (previewData: any, locale: string) => {
    if (previewData && previewData.length > 0 && this.activeBrand) {
      const data = previewData.filter((content: any) => {
        if (
          content.locale === locale &&
          content.brand === this.activeBrand.brand &&
          content.contentType === 'brandConfig'
        ) {
          return true
        } else {
          return false
        }
      })
      if (data && data.length > 0) {
        const brand = data[0]
        brand.slug = this.activeBrand.slug
        return data[0]
      }
    }
    return null
  }

  @action.bound
  setHeaderBackground = (transparent: boolean) => {
    this.transparent = transparent
  }

  @action.bound
  setActiveBrand = (brand: any) => {
    this.activeBrand = brand
  }
}
